// extracted by mini-css-extract-plugin
export default {"header":"Header_header__YtO2a","airplanes":"Header_airplanes__Ges69"};